import { createContext, useState } from "react";
import { Outlet } from "react-router-dom";

const FNMAuthContext = createContext({
  clientAuthInfo: {
    isLoggedIn: false,
    isLoading: true,
  },
  setClientAuthInfo: () => {},
});
export default FNMAuthContext;

export const FNMAuthContextProvider = () => {
  const [clientAuthInfo, setClientAuthInfo] = useState({
    isLoggedIn: false,
    isLoading: true,
  });

  const context = { clientAuthInfo, setClientAuthInfo };
  return (
    <FNMAuthContext.Provider value={context}>
      <Outlet />
    </FNMAuthContext.Provider>
  );
};
